<template>
  <table-layout :title="pageName">
    <template #buttons>
      <router-link v-if="!isUserAddresses" :to="createAddressLink">
        <b-button pill variant="purple" class="ml-1 mb-1"> آدرس جدید</b-button>
      </router-link>
    </template>
    <template #table>
      <b-table v-bind="tableAttributes" :fields="fields" :items="Addresses">
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <template #cell(address)="data">
          {{ data.item.province.name }} - {{ data.item.city.name }} -
          {{ data.item.address }}
        </template>

        <template #cell(action)="data">
          <span
              class="h5"
              @click="deleteAddress(data.item)"
              v-b-tooltip.hover
              title="حذف"
          >
            <b-icon icon="trash"></b-icon>
          </span>

          <span class="h5" v-b-tooltip.hover title="ویرایش">
            <router-link
                :to="{ name: 'UpdateAddress', params: { id: data.item.id } }"
            >
              <b-icon icon="pencil" class="mr-3"></b-icon>
            </router-link>
          </span>
        </template>
      </b-table>

      <div class="row pt-3">
        <div class="mt-3 color">
          <pagination :meta="meta" :on-change-page="changePage"/>
        </div>
      </div>
    </template>
  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import Pagination from "../../components/dashboard/Pagination.vue";
import TableLayout from "../../components/dashboard/TableLayout.vue";

export default {
  name: "Address",
  components: {Pagination, TableLayout},
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "name", label: "نام"},
        {key: "address", label: "آدرس"},
        {key: "action", label: ""},
      ],
    };
  },
  computed: {
    ...mapGetters({
      Addresses: "Address/getAddresses",
      meta: "Address/getMeta",
    }),
    createAddressLink() {
      if (this.isDefaultAddress) {
        return {name: 'CreateAddress', query: {mode: 'default-address'}}
      } else {
        return {name: 'CreateAddress'}
      }
    },
    isDefaultAddress() {
      return this.$route.name == 'DefaultAddresses'
    },
    isUserAddresses() {
      return this.$route.name == 'UserAddresses'
    },
    isCurrentUserAddresses() {
      return this.$route.name == 'Address'
    },
    pageName() {
      if (this.isDefaultAddress) {
        return 'آدرس های پیش فرض'
      }
      if (this.isUserAddresses) {
        return 'ادرس های کاربر'
      }
      if (this.isCurrentUserAddresses) {
        return 'آدرس های من'
      }
    },
  },
  mounted() {
    if (this.isDefaultAddress) {
      this.$store.dispatch("Address/setDefaultAddresses");
    }
    if (this.isUserAddresses) {
      const form = {
        user_id: this.$route.params.id,
        page: 1
      }
      this.$store.dispatch("Address/setUserAddresses", form);
    }
    if (this.isCurrentUserAddresses) {
      this.$store.dispatch("Address/setAddresses");
    }
  },
  methods: {
    changePage(page) {
      if (this.isDefaultAddress) {
        this.$store.dispatch("Address/setDefaultAddresses", page);
      }
      if (this.isUserAddresses) {
        const form = {
          user_id: this.$route.params.id,
          page: page
        }
        this.$store.dispatch("Address/setUserAddresses", form);
      }
      if (this.isCurrentUserAddresses) {
        this.$store.dispatch("Address/setAddresses", page);
      }
    },
    deleteAddress(address) {
      if (confirm("آیا از حذف آدرس مطمئن هستید؟")) {
        this.$store.dispatch("Address/deleteAddress", address);
      }
    },
  },
  watch: {
    '$route': {
      handler: function () {
        if (this.isDefaultAddress) {
          this.$store.dispatch("Address/setDefaultAddresses");
        }
        if (this.isUserAddresses) {
          const form = {
            user: this.$route.user_id
          }
          this.$store.dispatch("Address/setUserAddresses", form);
        }
        if (this.isCurrentUserAddresses) {
          this.$store.dispatch("Address/setAddresses");
        }
      },
    },
  }
};
</script>

<style scoped>
</style>